/**
 * Zone.js configuration flags
 * CRITICAL: Must be set BEFORE any imports
 */

// Prevents Angular change detection from running with certain Web Component callbacks
// Important for Ionic components performance
(window as any).__Zone_disable_customElements = true;

// Performance optimizations
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

/**
 * Now import Zone.js and Angular modules
 */
import 'zone.js'; // Required for Angular

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { enableProdMode, isDevMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { Capacitor } from '@capacitor/core';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { StorageRepository } from '@okcargo-apps/shared-domain';
import { apiInterceptor, APP_CONFIG, CapacitorStorageService } from '@okcargo-apps/shared-infrastructure';
import { provideCheckVersion } from '@okcargo-apps/utils-ionic';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

registerLocaleData(localeEs);

defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: APP_CONFIG,
      useValue: {
        ...environment,
        // firebase: firebaseConfig,
      },
    },
    { provide: StorageRepository, useClass: CapacitorStorageService },
    // TODO use APP_CONFIG with DI instead of environment
    provideCheckVersion({
      serverVersionsUrl: environment.versionsUrl,
      localVersionsUrl: environment.localVersionsUrl,
    }),
    provideZoneChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true,
    }),
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'es-ES' },
    provideServiceWorker('ngsw-worker.js', {
      enabled: (!isDevMode() || environment.production) && !Capacitor.isNativePlatform(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideTranslateService({
      fallbackLang: 'en',
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
  ],
});
